// extracted by mini-css-extract-plugin
export var cardContainer = "_nn-0";
export var cardHeader = "_nn-2";
export var collapsedState = "_nn-3";
export var dragHandle = "_nn-5";
export var dragHandleIcon = "_nn-6";
export var dragging = "_nn-1";
export var titleArea = "_nn-4";